import React, { useMemo, useState } from "react";
import {
    Search,
    Shield,
    Globe,
    FileJson,
    Code2,
    Copy,
    CheckCircle2,
    Server,
    ArrowRight,
    BookOpen,
    CreditCard,
    BarChart3,
    ChevronDown,
} from "lucide-react";
import { encrtypth } from "../../service/CoreFunctions";
import { PasswordInput } from "../../components/ui/PasswordInput";

const baseUrls = [
    { name: "Production", url: "https://paylink.mn/api/v1" },
    { name: "Test", url: "https://pay-link.fiba.mn/api/v1" },
];

const endpoints = [
    {
        pc: "cu0900",
        title: "Нэхэмжлэх үүсгэх",
        group: "Invoice",
        summary: "Шинэ invoice үүсгэж payment_link буцаана.",
        request: {
            amount_total: 1010.1,
            count_total: 1,
            amount: 1010.1,
            txndesc: "Single invoice",
            merchant_ref: "REF-0001",
            fee_percent: 1,
            fee_amount: 10.1,
            base_amount: 1000,
        },
        response: {
            response_code: "RC000000",
            response: {
                invid: "inv_mmln6uaf8c1808",
                payment_link: "https://paylink.mn/api/s/inv_mmln6uaf8c1808",
                status: "pending",
                amount_total: 1010.1,
                currency: "MNT",
            },
        },
    },
    {
        pc: "cu0901",
        title: "Нэхэмжлэх жагсаалт",
        group: "Invoice",
        summary: "Invoice жагсаалтыг filter, pagination, sort-той буцаана.",
        request: {
            id: "250",
            merchant_ref: "",
            status: "",
            date_from: "",
            date_to: "",
            skip: 0,
            take: 20,
            sort: [{ field: "created_at", dir: "desc" }],
        },
        response: {
            response_code: "RC000000",
            response: [
                {
                    id: 263,
                    invid: "inv_mmln6uaf8c1808",
                    status: "pending",
                    amount_total: 1010.1,
                    can_cancel: "1",
                },
            ],
        },
    },
    {
        pc: "cu0904",
        title: "Нэхэмжлэх дэлгэрэнгүй",
        group: "Invoice",
        summary: "Тодорхой invoice-ийн header болон transactions array-г буцаана.",
        request: { invid: "inv_mmix6fkh130ae2" },
        response: {
            response_code: "RC000000",
            response: {
                id: 248,
                invid: "inv_mmix6fkh130ae2",
                status: "paid",
                amount_total: 827272.73,
                transactions: [
                    {
                        id: 264,
                        amount: 82727.27,
                        currency: "MNT",
                        description: "Орхоо",
                        statusid: "1",
                        callbacked_at: "2026-03-11 14:33:13",
                        ordernum: "07fdb6mmlnwubk",
                        amount_fee: 827.27,
                        settle_at: null,
                        settle_amount: 0,
                    },
                ],
            },
        },
    },
    {
        pc: "cu0905",
        title: "Нэхэмжлэх цуцлах",
        group: "Invoice",
        summary: "Цуцлах боломжтой invoice-г canceled төлөвт оруулна.",
        request: { invid: "inv_mmln6uaf8c1808" },
        response: {
            response_code: "RC000000",
            response: { status: "ok", message: "Canceled" },
        },
    },
    {
        pc: "cu0906",
        title: "Багц нэхэмжлэхийг төлөгдсөн болгох",
        group: "Invoice",
        summary: "Batch invoice-ийн үлдэгдлийг manual paid гэж хаана.",
        request: { invid: "inv_mmix6fkh130ae2" },
        response: {
            response_code: "RC000000",
            response: {
                status: "ok",
                message: "Marked as paid (manual remaining)",
                data: {
                    amount_total: 827272.73,
                    system_paid: 82727.27,
                    manual_paid: 744545.46,
                    remaining: 0,
                },
            },
        },
    },
    {
        pc: "cu0907",
        title: "Нэхэмжлэхийн тайлан",
        group: "Reports",
        summary: "Invoice report жагсаалтыг pagination, sort-той буцаана.",
        request: {
            id: "",
            merchant_ref: "",
            status: "",
            date_from: "",
            date_to: "",
            skip: 0,
            take: 20,
            sort: [{ field: "created_at", dir: "desc" }],
        },
        response: {
            response_code: "RC000000",
            response: {
                data: [
                    {
                        rn: "1",
                        id: "263",
                        invid: "inv_mmln6uaf8c1808",
                        status: "canceled",
                        amount_total: "1010.1",
                        created_at: "2026-03-11 14:12:41",
                    },
                ],
                total: 6,
            },
        },
    },
    {
        pc: "cu0908",
        title: "Нэхэмжлэхийн хураангуй тайлан",
        group: "Reports",
        summary: "Invoice summary metric-үүдийг буцаана.",
        request: { id: "", merchant_ref: "", status: "", date_from: "", date_to: "" },
        response: {
            response_code: "RC000000",
            response: {
                total_count: "6",
                total_amount_total: "919090.91",
                paid_count: "4",
                paid_amount_total: "835353.54",
                pending_count: "1",
                pending_amount_total: "82727.27",
                canceled_count: "1",
                expired_count: "0",
            },
        },
    },
    {
        pc: "cu0909",
        title: "Гүйлгээний тайлан",
        group: "Reports",
        summary: "Transaction report жагсаалтыг pagination, sort-той буцаана.",
        request: {
            invoice_id: "",
            date_from: "",
            date_to: "",
            statusid: null,
            skip: 0,
            take: 20,
            sort: [{ field: "created_at", dir: "desc" }],
        },
        response: {
            response_code: "RC000000",
            response: {
                data: [
                    {
                        rn: "1",
                        id: "264",
                        invid: "inv_mmix6fkh130ae2",
                        status: "Approved",
                        amount: "82727.27",
                        amount_fee: "827.27",
                    },
                ],
                total: 4,
            },
        },
    },
    {
        pc: "cu0910",
        title: "Гүйлгээний хураангуй тайлан",
        group: "Reports",
        summary: "Transaction summary metric-үүдийг буцаана.",
        request: { invoice_id: "", date_from: "", date_to: "" },
        response: {
            response_code: "RC000000",
            response: {
                total_amount: "178585.86",
                total_fee: "908.08",
                total_settle_amount: "0",
                approved_count: "4",
            },
        },
    },
];

const statusRows = [
    { type: "Invoice", code: "pending", desc: "Хүлээгдэж буй" },
    { type: "Invoice", code: "paid", desc: "Төлөгдсөн" },
    { type: "Invoice", code: "canceled", desc: "Цуцлагдсан" },
    { type: "Invoice", code: "expired", desc: "Хугацаа дууссан" },
    { type: "Transaction", code: "approved", desc: "Амжилттай" },
    { type: "Transaction", code: "statusid=1", desc: "Approved / Амжилттай" },
];

const errorRows = [
    ["RC000000", "Амжилттай"],
    ["RC000001", "pc тодорхойлогдоогүй байна."],
    ["RC000002", "Process code бүртгэлгүй байна."],
    ["RC000003", "Системд алдаа гарлаа."],
    ["RC000004", "Нэвтрэх мэдээлэл буруу байна."],
    ["RC000005", "Та нэвтрэх боломжгүй байна."],
    ["RC000006", "Системд нэвтрээгүй байна."],
    ["RC000015", "Харилцагчийн бүртгэл олдсонгүй."],
    ["RC000027", "Бүртгэл олдсонгүй."],
    ["RC000028", "Бүртгэлтэй байна."],
    ["VC000008", ":field талбар бөглөгдөөгүй байна."],
    ["VC000012", "Хуудаслалт буруу байна."],
];

function Badge({ children, variant = "default", className = "" }) {
    const base = "inline-flex items-center rounded-full px-3 py-1 text-xs font-medium";
    const styles =
        variant === "outline"
            ? "border border-slate-300 bg-white text-slate-700"
            : variant === "secondary"
                ? "bg-slate-100 text-slate-700"
                : "bg-slate-900 text-white";

    return <span className={`${base} ${styles} ${className}`}>{children}</span>;
}

function Button({
    children,
    onClick,
    variant = "default",
    size = "md",
    className = "",
    ...props
}) {
    const base =
        "inline-flex items-center justify-center rounded-xl font-medium transition focus:outline-none focus:ring-2 focus:ring-slate-400 disabled:opacity-50 disabled:pointer-events-none";
    const variants =
        variant === "outline"
            ? "border border-slate-300 bg-white text-slate-800 hover:bg-slate-50"
            : "bg-slate-900 text-white hover:bg-slate-800";
    const sizes =
        size === "sm" ? "h-9 px-3 text-sm" : "h-10 px-4 text-sm";

    return (
        <button onClick={onClick} className={`${base} ${variants} ${sizes} ${className}`} {...props}>
            {children}
        </button>
    );
}

function Input({ className = "", ...props }) {
    return (
        <input
            className={`flex h-10 w-full rounded-xl border border-slate-300 bg-white px-3 text-sm outline-none ring-0 placeholder:text-slate-400 focus:border-slate-500 ${className}`}
            {...props}
        />
    );
}

function Card({ children, className = "" }) {
    return <div className={`rounded-3xl border border-slate-200 bg-white ${className}`}>{children}</div>;
}

function CardHeader({ children, className = "" }) {
    return <div className={`p-6 ${className}`}>{children}</div>;
}

function CardContent({ children, className = "" }) {
    return <div className={`px-6 pb-6 ${className}`}>{children}</div>;
}

function CardTitle({ children, className = "" }) {
    return <h3 className={`font-semibold text-slate-900 ${className}`}>{children}</h3>;
}

function CardDescription({ children, className = "" }) {
    return <p className={`text-sm text-slate-500 ${className}`}>{children}</p>;
}

function CopyButton({ value }) {
    const [copied, setCopied] = useState(false);

    return (
        <Button
            variant="outline"
            size="sm"
            className="gap-2"
            onClick={async () => {
                await navigator.clipboard.writeText(value);
                setCopied(true);
                setTimeout(() => setCopied(false), 1200);
            }}
        >
            {copied ? <CheckCircle2 className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
            {copied ? "Copied" : "Copy"}
        </Button>
    );
}

function JsonBlock({ title, data }) {
    const pretty = JSON.stringify(data, null, 2);

    return (
        <div className="rounded-2xl border border-slate-200 bg-white shadow-sm">
            <div className="flex items-center justify-between gap-3 p-6 pb-3">
                <h3 className="text-base font-semibold text-slate-900">{title}</h3>
                <CopyButton value={pretty} />
            </div>

            <div className="px-6 pb-6">
                <pre
                    className="overflow-x-auto rounded-2xl p-4 text-xs leading-6"
                    style={{
                        backgroundColor: "#020617",
                        color: "#ffffff",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                    }}
                >
                    {pretty}
                </pre>
            </div>
        </div>
    );
}

function SectionTabs({ tab, setTab }) {
    const items = [
        { key: "overview", label: "Overview" },
        { key: "request", label: "Request" },
        { key: "response", label: "Response" },
        { key: "curl", label: "cURL" },
    ];

    return (
        <div className="mb-4 grid w-full grid-cols-2 gap-2 rounded-2xl bg-slate-100 p-1 md:grid-cols-4">
            {items.map((item) => (
                <button
                    key={item.key}
                    onClick={() => setTab(item.key)}
                    className={`rounded-2xl px-4 py-2 text-sm font-medium transition ${tab === item.key
                        ? "bg-white text-slate-900 shadow-sm"
                        : "text-slate-600 hover:text-slate-900"
                        }`}
                >
                    {item.label}
                </button>
            ))}
        </div>
    );
}

function Accordion({ open, setOpen, title, children }) {
    return (
        <div className="w-full rounded-2xl border border-slate-200">
            <button
                type="button"
                onClick={() => setOpen(!open)}
                className="flex w-full items-center justify-between px-4 py-4 text-left"
            >
                <span className="font-medium text-slate-900">{title}</span>
                <ChevronDown
                    className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`}
                />
            </button>
            {open && <div className="border-t border-slate-200 px-4 py-4">{children}</div>}
        </div>
    );
}

export default function PayLinkApiDocs() {
    const [query, setQuery] = useState("");
    const [selectedPc, setSelectedPc] = useState("cu0900");
    const [tab, setTab] = useState("overview");
    const [notesOpen, setNotesOpen] = useState(true);
    const [hashPassword, setHashPassword] = useState("");

    const filtered = useMemo(() => {
        const q = query.trim().toLowerCase();
        if (!q) return endpoints;

        return endpoints.filter(
            (e) =>
                e.pc.toLowerCase().includes(q) ||
                e.title.toLowerCase().includes(q) ||
                e.group.toLowerCase().includes(q) ||
                e.summary.toLowerCase().includes(q)
        );
    }, [query]);

    const active = endpoints.find((e) => e.pc === selectedPc) || endpoints[0];

    const curlExample = `curl --request POST \\
  --url '${baseUrls[0].url}/external/process' \\
  --header 'pc: ${active.pc}' \\
  --header 'X-USERNAME: xxx' \\
  --header 'X-SIGNATURE: xxx' \\
  --header 'Content-Type: application/json' \\
  --header 'Accept: application/json' \\
  --data '${JSON.stringify(active.request)}'`;

    return (
        <div className="min-h-screen bg-slate-50 text-slate-900">
            <div className="border-b bg-white/90 backdrop-blur">
                <div className="mx-auto grid max-w-7xl gap-6 px-6 py-10 lg:grid-cols-[1.5fr_1fr] lg:items-center">
                    <div>
                        <Badge className="mb-4 rounded-full px-3 py-1 text-xs">
                            PayLink Developer Portal
                        </Badge>

                        <h1 className="text-4xl font-semibold tracking-tight">
                            PayLink External API
                        </h1>

                        <p className="mt-4 max-w-2xl text-base text-slate-600">
                            Нэг endpoint, олон процесс. Бүх хүсэлт{" "}
                            <code className="rounded bg-slate-100 px-1.5 py-0.5">
                                POST /external/process
                            </code>{" "}
                            endpoint ашиглаж, API төрлөө{" "}
                            <code className="rounded bg-slate-100 px-1.5 py-0.5">pc</code>{" "}
                            header-ээр сонгоно.
                        </p>

                        <div className="mt-6 flex flex-wrap gap-3">
                            <Badge variant="secondary" className="rounded-full px-3 py-1">
                                HTTPS + JSON
                            </Badge>
                            <Badge variant="secondary" className="rounded-full px-3 py-1">
                                HTTP 200 Always
                            </Badge>
                            <Badge variant="secondary" className="rounded-full px-3 py-1">
                                response_code Driven
                            </Badge>
                            <Badge variant="secondary" className="rounded-full px-3 py-1">
                                Date: YYYY-MM-DD HH24:MI:SS
                            </Badge>
                        </div>
                    </div>

                    <div>
                        <Card className="rounded-3xl border-slate-200 shadow-sm">
                            <CardHeader>
                                <CardTitle className="flex items-center gap-2 text-lg">
                                    <Globe className="h-5 w-5" />
                                    Environment
                                </CardTitle>
                                <CardDescription>
                                    Production болон Test endpoint
                                </CardDescription>
                            </CardHeader>

                            <CardContent className="space-y-4">
                                {baseUrls.map((item) => (
                                    <div key={item.name} className="rounded-2xl border p-4">
                                        <div className="mb-2 flex items-center justify-between gap-2">
                                            <span className="font-medium">{item.name}</span>
                                            <CopyButton value={item.url} />
                                        </div>
                                        <code className="block break-all text-sm text-slate-700">
                                            {item.url}
                                        </code>
                                    </div>
                                ))}
                            </CardContent>
                        </Card>
                    </div>
                </div>
            </div>

            <div className="mx-auto max-w-7xl px-6 py-8">
                <div className="grid gap-6 lg:grid-cols-[320px_1fr]">
                    <div className="space-y-6">
                        <Card className="rounded-3xl shadow-sm">
                            <CardHeader>
                                <CardTitle className="flex items-center gap-2 text-lg">
                                    <Search className="h-5 w-5" />
                                    API Explorer
                                </CardTitle>
                                <CardDescription>Process code эсвэл нэрээр хайна</CardDescription>
                            </CardHeader>

                            <CardContent>
                                <Input
                                    value={query}
                                    onChange={(e) => setQuery(e.target.value)}
                                    placeholder="cu0900, invoice, тайлан..."
                                    className="mb-4"
                                />

                                <div className="max-h-[420px] overflow-y-auto pr-2">
                                    <div className="space-y-2">
                                        {filtered.map((endpoint) => (
                                            <button
                                                key={endpoint.pc}
                                                onClick={() => {
                                                    setSelectedPc(endpoint.pc);
                                                    setTab("overview");
                                                }}
                                                className={`w-full rounded-2xl border p-4 text-left transition ${selectedPc === endpoint.pc
                                                    ? "border-slate-900 bg-slate-900 text-white"
                                                    : "bg-white hover:bg-slate-50"
                                                    }`}
                                            >
                                                <div className="mb-2 flex items-center justify-between gap-3">
                                                    <Badge
                                                        variant={selectedPc === endpoint.pc ? "secondary" : "outline"}
                                                    >
                                                        {endpoint.pc}
                                                    </Badge>
                                                    <span
                                                        className={`text-xs ${selectedPc === endpoint.pc
                                                            ? "text-slate-300"
                                                            : "text-slate-500"
                                                            }`}
                                                    >
                                                        {endpoint.group}
                                                    </span>
                                                </div>

                                                <div className="font-medium">{endpoint.title}</div>
                                                <div
                                                    className={`mt-1 text-sm ${selectedPc === endpoint.pc
                                                        ? "text-slate-300"
                                                        : "text-slate-500"
                                                        }`}
                                                >
                                                    {endpoint.summary}
                                                </div>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </CardContent>
                        </Card>

                        <Card className="rounded-3xl shadow-sm">
                            <CardHeader>
                                <CardTitle className="flex items-center gap-2 text-lg">
                                    <Shield className="h-5 w-5" />
                                    Required Headers
                                </CardTitle>
                            </CardHeader>

                            <CardContent className="space-y-3 text-sm">
                                <div className="rounded-2xl border p-3">
                                    <strong>pc</strong> — Process code
                                </div>
                                <div className="rounded-2xl border p-3">
                                    <strong>X-USERNAME</strong> — Request Username
                                </div>
                                <div className="rounded-2xl border p-3">
                                    <strong>X-SIGNATURE</strong> — Request signature

                                    <div className="mt-2 flex items-stretch gap-2">
                                        <div className="flex-1">
                                            <PasswordInput
                                                placeholder="Password"
                                                onChange={(event) => {
                                                    setHashPassword(encrtypth(event.target.value))
                                                }}
                                                className="h-full pl-10"
                                            />
                                        </div>

                                        <CopyButton value={hashPassword} className="h-full" />
                                    </div>
                                </div>
                                <div className="rounded-2xl border p-3">
                                    <strong>Content-Type</strong> — application/json
                                </div>
                                <div className="rounded-2xl border p-3">
                                    <strong>Accept</strong> — application/json
                                </div>
                            </CardContent>
                        </Card>
                    </div>

                    <div className="space-y-6">
                        <Card className="rounded-3xl shadow-sm">
                            <CardHeader>
                                <div className="flex flex-wrap items-center justify-between gap-3">
                                    <div>
                                        <CardTitle className="text-2xl">{active.title}</CardTitle>
                                        <CardDescription className="mt-1">
                                            {active.summary}
                                        </CardDescription>
                                    </div>

                                    <div className="flex items-center gap-2">
                                        <Badge className="rounded-full px-3 py-1">{active.pc}</Badge>
                                        <Badge variant="outline" className="rounded-full px-3 py-1">
                                            POST /external/process
                                        </Badge>
                                    </div>
                                </div>
                            </CardHeader>

                            <CardContent>
                                <SectionTabs tab={tab} setTab={setTab} />

                                {tab === "overview" && (
                                    <div className="space-y-4">
                                        <div className="grid gap-4 md:grid-cols-3">
                                            <Card className="rounded-2xl">
                                                <CardContent className="flex items-center gap-3 p-5">
                                                    <Server className="h-5 w-5" />
                                                    <div>
                                                        <div className="text-sm text-slate-500">Endpoint</div>
                                                        <div className="font-medium">/external/process</div>
                                                    </div>
                                                </CardContent>
                                            </Card>

                                            <Card className="rounded-2xl">
                                                <CardContent className="flex items-center gap-3 p-5">
                                                    <FileJson className="h-5 w-5" />
                                                    <div>
                                                        <div className="text-sm text-slate-500">Payload Type</div>
                                                        <div className="font-medium">application/json</div>
                                                    </div>
                                                </CardContent>
                                            </Card>

                                            <Card className="rounded-2xl">
                                                <CardContent className="flex items-center gap-3 p-5">
                                                    <Shield className="h-5 w-5" />
                                                    <div>
                                                        <div className="text-sm text-slate-500">Success Rule</div>
                                                        <div className="font-medium">
                                                            response_code = RC000000
                                                        </div>
                                                    </div>
                                                </CardContent>
                                            </Card>
                                        </div>

                                        <Accordion
                                            open={notesOpen}
                                            setOpen={setNotesOpen}
                                            title="Integration Notes"
                                        >
                                            <div className="space-y-2 text-sm text-slate-600">
                                                <p>
                                                    Бүх хүсэлт HTTP 200 буцаана. Алдаа/амжилтыг зөвхөн{" "}
                                                    <code>response_code</code>-оор танина.
                                                </p>
                                                <p>
                                                    Datetime форматыг timezone-aware байдлаар боловсруулахыг
                                                    зөвлөж байна.
                                                </p>
                                                <p>
                                                    Batch invoice-д <code>count_total</code>, төлөгдсөн дүнд{" "}
                                                    <code>count</code> болон transaction array ашиглагдана.
                                                </p>
                                            </div>
                                        </Accordion>
                                    </div>
                                )}

                                {tab === "request" && (
                                    <div className="space-y-4">
                                        <JsonBlock title="Request Payload" data={active.request} />
                                    </div>
                                )}

                                {tab === "response" && (
                                    <div className="space-y-4">
                                        <JsonBlock title="Success Response" data={active.response} />
                                        <JsonBlock
                                            title="Common Error Response"
                                            data={{
                                                response_code: "RC000006",
                                                response: "RC000006 - Системд нэвтрээгүй байна.",
                                            }}
                                        />
                                    </div>
                                )}

                                {tab === "curl" && (
                                    <div className="space-y-4">
                                        <div className="rounded-2xl border border-slate-200 bg-white shadow-sm">
                                            <div className="flex items-center justify-between gap-3 p-6 pb-3">
                                                <h3 className="text-base font-semibold text-slate-900">cURL Example</h3>
                                                <CopyButton value={curlExample} />
                                            </div>

                                            <div className="px-6 pb-6">
                                                <pre
                                                    className="overflow-x-auto rounded-2xl p-4 text-xs leading-6"
                                                    style={{
                                                        backgroundColor: "#020617",
                                                        color: "#ffffff",
                                                        whiteSpace: "pre-wrap",
                                                        wordBreak: "break-word",
                                                    }}
                                                >
                                                    {curlExample}
                                                </pre>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </CardContent>
                        </Card>

                        <div className="grid gap-6 xl:grid-cols-2">
                            <Card className="rounded-3xl shadow-sm">
                                <CardHeader>
                                    <CardTitle className="flex items-center gap-2 text-lg">
                                        <BookOpen className="h-5 w-5" />
                                        Status Mapping
                                    </CardTitle>
                                </CardHeader>

                                <CardContent>
                                    <div className="space-y-3">
                                        {statusRows.map((row) => (
                                            <div
                                                key={row.type + row.code}
                                                className="flex items-center justify-between rounded-2xl border p-3 text-sm"
                                            >
                                                <div>
                                                    <div className="font-medium">{row.code}</div>
                                                    <div className="text-slate-500">{row.type}</div>
                                                </div>
                                                <Badge variant="outline">{row.desc}</Badge>
                                            </div>
                                        ))}
                                    </div>
                                </CardContent>
                            </Card>

                            <Card className="rounded-3xl shadow-sm">
                                <CardHeader>
                                    <CardTitle className="flex items-center gap-2 text-lg">
                                        <Code2 className="h-5 w-5" />
                                        Common Response Codes
                                    </CardTitle>
                                </CardHeader>

                                <CardContent>
                                    <div className="space-y-3">
                                        {errorRows.map(([code, desc]) => (
                                            <div
                                                key={code}
                                                className="flex items-center justify-between gap-3 rounded-2xl border p-3 text-sm"
                                            >
                                                <code className="font-semibold">{code}</code>
                                                <span className="text-right text-slate-600">{desc}</span>
                                            </div>
                                        ))}
                                    </div>
                                </CardContent>
                            </Card>
                        </div>

                        <div className="grid gap-6 md:grid-cols-3">
                            <Card className="rounded-3xl shadow-sm">
                                <CardHeader>
                                    <CardTitle className="flex items-center gap-2 text-lg">
                                        <CreditCard className="h-5 w-5" />
                                        Invoice APIs
                                    </CardTitle>
                                </CardHeader>

                                <CardContent className="space-y-3 text-sm text-slate-600">
                                    <div className="rounded-2xl border p-3">cu0900 — Нэхэмжлэх үүсгэх</div>
                                    <div className="rounded-2xl border p-3">cu0901 — Нэхэмжлэх жагсаалт</div>
                                    <div className="rounded-2xl border p-3">cu0904 — Нэхэмжлэх дэлгэрэнгүй</div>
                                    <div className="rounded-2xl border p-3">cu0905 — Нэхэмжлэх цуцлах</div>
                                    <div className="rounded-2xl border p-3">
                                        cu0906 — Багц нэхэмжлэхийг төлөгдсөн болгох
                                    </div>
                                </CardContent>
                            </Card>

                            <Card className="rounded-3xl shadow-sm">
                                <CardHeader>
                                    <CardTitle className="flex items-center gap-2 text-lg">
                                        <BarChart3 className="h-5 w-5" />
                                        Report APIs
                                    </CardTitle>
                                </CardHeader>

                                <CardContent className="space-y-3 text-sm text-slate-600">
                                    <div className="rounded-2xl border p-3">cu0907 — Нэхэмжлэхийн тайлан</div>
                                    <div className="rounded-2xl border p-3">
                                        cu0908 — Нэхэмжлэхийн хураангуй тайлан
                                    </div>
                                    <div className="rounded-2xl border p-3">cu0909 — Гүйлгээний тайлан</div>
                                    <div className="rounded-2xl border p-3">
                                        cu0910 — Гүйлгээний хураангуй тайлан
                                    </div>
                                </CardContent>
                            </Card>

                            <Card className="rounded-3xl shadow-sm">
                                <CardHeader>
                                    <CardTitle className="flex items-center gap-2 text-lg">
                                        <ArrowRight className="h-5 w-5" />
                                        Integration Flow
                                    </CardTitle>
                                </CardHeader>

                                <CardContent className="space-y-3 text-sm text-slate-600">
                                    <div className="rounded-2xl border p-3">1. Create invoice</div>
                                    <div className="rounded-2xl border p-3">
                                        2. Redirect user to payment_link
                                    </div>
                                    <div className="rounded-2xl border p-3">
                                        3. Poll invoice detail / reports
                                    </div>
                                    <div className="rounded-2xl border p-3">
                                        4. Reconcile through summary APIs
                                    </div>
                                </CardContent>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}